import { useContext } from "react";
import { UserContext } from "../context/UserContext";

export const useAuth = () => {
  const ctx = useContext(UserContext);

  if (!ctx) {
    return {
      user: null,
      loading: true,
      refresh: async () => null,
      logout: () => {}, // Safe fallback
    };
  }

  // ✅ Extract 'logout' from context
  const { user, loading, refreshUser, logout } = ctx;
  
  // ✅ Return 'logout' so VerifyEmail.js can use it
  return { user, loading, refresh: refreshUser, logout };
};